import type { ReactNode } from 'react';

export type PopupViewProps = {
  show?: boolean;
  onClose?: () => void;
  children?: ReactNode;
};

export function PopupView({ show = false, onClose, children }: PopupViewProps) {
  if (!show) {
    return null;
  }

  return (
    <div
      className="popup-content bg-white border border-dark rounded-3 p-2 shadow position-absolute"
      style={{ minWidth: 300 }}
    >
      <button
        type="button"
        className="btn-close position-absolute top-0 end-0 mt-1 me-1"
        aria-label="Close"
        onClick={onClose}
      ></button>

      {children}
    </div>
  );
}
